<template>
  <view
    class="skeleton-container"
    wx:if="{{showSkeleton}}"
  >
    <view wx:style="{{ {background: '#fff', marginBottom: '10px'} }}">
      <es-navbar wx:style="{{navbarStyle}}" left-arrow="{{true}}" bind:click-left="goBackReport" onClickLeft="{{homeBack}}">
        <view wx:if="{{isScramble}}">备选车次</view>
        <view class="es-navbar-title" wx:elif="{{!fromChangeTicket}}">
          <view class="es-navbar-title-text" bindtap="reverseCity">
            {{ title[0] }}
            <view class="title-switch-icon"></view>
            {{ title[1] }}
          </view>
        </view>
        <change-navbar process="{{0}}" wx:else />
      </es-navbar>
      <view wx:style="{{{paddingBottom: '0.5px'}}}">
        <es-date
          wx:if="{{!isScramble}}"
          wx:ref="es_date"
          value="{{time}}"
          date-type="{{'MM-dd'}}"
          checkType="single"
          linking="{{linking}}"
          isUpdateEveryTime="{{true}}"
          checkRange="{{14}}"
          maxDate="{{maxDateTime}}"
          minDate="{{minDateTime}}"
          maxHeaderDate="{{headerMaxDateTime}}"
          minHeaderDate="{{headerMinDateTime}}"
          startText="去程"
          endText="返程"
          title="选择前往日期"
          closeable="{{true}}"
          isRequest="{{pageLoading}}"
          bind:confirm="onConfirm"
          bind:handleClickDay="handleClickDay"
        />
      </view>
    </view>
    <view class="skeleton">
      <view class="skeleton-item" wx:for="{{10}}">
        <view class="skeleton-item-1"/><view class="skeleton-item-2"/><view class="skeleton-item-3"/><view class="skeleton-item-4"/><view class="skeleton-item-5"/><view class="skeleton-item-6"/>
      </view>
    </view>
  </view>
  <es-over-layout
    custom-class="{{isScramble ? 'list-custom-class-scramble' : 'list-custom-class'}}"
    layout="{{['header', 'footer']}}"
    esMainStyle="{{esMainStyle}}"
    useDefaultNavbar="{{false}}"
    useBlankPage="{{useBlankPage}}"
    blankImageUrl="{{blankImageUrl}}"
    blankContextTitle="{{blankContextTitle}}"
    blankContextSubTitle="{{blankContextSubTitle}}"
    hasBlankButton="{{hasButton}}"
    blankPageType="blank-page"
    bind:blank-retry="clickButton"
    wx:else
  >
    <view slot="header" class="list-header">
      <es-navbar wx:style="{{navbarStyle}}" left-arrow="{{true}}" bind:click-left="goBackReport" onClickLeft="{{homeBack}}">
        <view wx:if="{{isScramble}}">备选车次</view>
        <view class="es-navbar-title" wx:elif="{{!fromChangeTicket}}" >
          <view class="es-navbar-title-text" bindtap="reverseCity">
            {{ title[0] }}
            <view class="title-switch-icon"></view>
            {{ title[1] }}
          </view>
        </view>
        <change-navbar process="{{0}}" wx:else />
      </es-navbar>
      <es-date
        wx:if="{{!isScramble}}"
        wx:ref="es_date"
        value="{{time}}"
        date-type="{{'MM-dd'}}"
        checkType="single"
        linking="{{linking}}"
        isUpdateEveryTime="{{true}}"
        checkRange="{{14}}"
        maxDate="{{maxDateTime}}"
        minDate="{{minDateTime}}"
        maxHeaderDate="{{headerMaxDateTime}}"
        minHeaderDate="{{headerMinDateTime}}"
        startText="去程"
        endText="返程"
        title="选择前往日期"
        closeable="{{true}}"
        bind:confirm="onConfirm"
        bind:handleClickDay="handleClickDay"
      />
      <!-- 提示条 -->
      <view class="notice-tips" wx:if="{{serviceNoticeList && serviceNoticeList.length && !isScramble}}">
        <notice-tip
          wx:for="{{serviceNoticeList}}"
          wx:key="index"
          titleText="{{item.title}}"
          bindclick="showTipsPop(index)"
        />
      </view>
       <view class="use-blankp-page-tab" wx:if="{{!fromChangeTicket && !isScramble && useBlankPage && !isAliAndNotLogin}}">
        <view class="header-item-wrapper">
          <Tab
            tabKey="{{unionType}}"
            tabList="{{tabList}}"
            bind:settabkey="setUnionType"
          />
        </view>
        <top-condition-bar
          unionType="{{unionType}}"
          trainListSearchQuery="{{trainListSearchQuery}}"
          bind:parentDataChange="updateData"
          bind:getTrainListFunc="getTrainListFunc(false)"
        />
        <view class="coupon-banner" wx:if="{{!isScramble && !isAliAndNotLogin && useBlankPage}}">
          <coupon-banner-simplify  isShowNoticeTip="{{!!serviceNoticeList.length}}" />
        </view>
        <airflow-train-guide-card
          wx:if="{{ !isFromAirflowGuideCard && airflowTrainGuideCardInfo.title }}"
          extern-class="airflow-train-guide-card-container"
          trackType="{{airflowTrainGuideCardInfo.type}}"
          type="flight"
          cardIcon="{{airflowTrainGuideCardInfo.icon}}"
          iconDesc="{{airflowTrainGuideCardInfo.title}}"
          departureStation="{{airflowTrainGuideCardInfo.dep_city_name}}"
          arrivalStation="{{airflowTrainGuideCardInfo.arr_city_name}}"
          elapsedTime="{{airflowTrainGuideCardInfo.travel_time}}"
          personalizedCopy="{{airflowTrainGuideCardInfo.desc}}"
          ticketPrice="{{airflowTrainGuideCardInfo.show_price/100}}"
          bind:click="gotoFlightList"
        />
      </view>
      <view class="black-page-line" wx:if="{{useBlankPage}}" />
        <view wx:if="{{isScramble}}">
          <train-list-condition-bar
            wx:ref="conditionbar"
            trainListSearchQuery="{{trainListSearchQuery}}"
            selectCityList="{{selectCityList}}"
            bind:parentDataChange="updateData"
            bind:getTrainListFunc="getTrainListFunc(false)"
            bind:reportClick="conditionBarClickReport"
            isScramble
          />
        </view>
      </view>
    <!-- 简易版 - 券 banner -->
    <view 
      class="train-list-container" 
      wx:class="{{isScramble && 'scrambling', showSkeleton && 'train-list-container-skeleton'}}"
      wx:style="{{isScramble ? 'paddingBottom: 0' : ''}}"
      bind:scroll="handleScroll"
     >
     <view class="header-item-wrapper tab" wx:if="{{!fromChangeTicket && !isScramble && !isAliAndNotLogin}}">
       <Tab 
          tabKey="{{unionType}}" 
          tabList="{{tabList}}"
          bind:settabkey="setUnionType"
        />
     </view>
     <view class="header-item-wrapper sticky" wx:if="{{!isScramble}}">
      <top-condition-bar 
        unionType="{{unionType}}"
        trainListSearchQuery="{{trainListSearchQuery}}"
        bind:parentDataChange="updateData"
        bind:getTrainListFunc="getTrainListFunc(false)"
      />   
     </view> 
     <view class="header-item-wrapper coupon-banner" wx:if="{{!isScramble && !isAliAndNotLogin}}">
      <coupon-banner-simplify  isShowNoticeTip="{{!!serviceNoticeList.length}}" />
     </view>
     <view class="header-item-wrapper guide-tip" wx:if="{{showPreScrambleGuide}}">
      <guide-tips />
     </view>
      <union-login-card wx:if="{{showUnionLoginCard}}"/>
      <view class="item-container" wx:else>
        <airflow-train-guide-card
          wx:if="{{ !isFromAirflowGuideCard && airflowTrainGuideCardInfo.title }}"
          extern-class="airflow-train-guide-card-container"
          trackType="{{airflowTrainGuideCardInfo.type}}"
          type="flight"
          cardIcon="{{airflowTrainGuideCardInfo.icon}}"
          iconDesc="{{airflowTrainGuideCardInfo.title}}"
          departureStation="{{airflowTrainGuideCardInfo.dep_city_name}}"
          arrivalStation="{{airflowTrainGuideCardInfo.arr_city_name}}"
          elapsedTime="{{airflowTrainGuideCardInfo.travel_time}}"
          personalizedCopy="{{airflowTrainGuideCardInfo.desc}}"
          ticketPrice="{{airflowTrainGuideCardInfo.show_price/100}}"
          bind:click="gotoFlightList"
        />
        <view
          class="train-list-container-item"
          wx:for="{{trainList}}"
          wx:key="index"
        >
          <train-info-card
            trainInfo="{{item}}"
            isScramble="{{isScramble}}"
            bindgoDetail="goDetail(item, index)"
            fromChangeTicket="{{fromChangeTicket}}"
            include="{{scrambleInclude(item)}}"
            current="{{current}}"
          />
        </view>
        <Loading wx:if="{{pageNumber > 1 && pageLoading}}"/>
      </view>
    </view>
    <view style="width: 100%" slot="footer" wx:if="{{!isScramble}}">
      <train-list-condition-bar
        wx:ref="normalContionBar"
        trainListSearchQuery="{{trainListSearchQuery}}"
        selectCityList="{{selectCityList}}"
        bind:parentDataChange="updateData"
        bind:getTrainListFunc="getTrainListFunc(false)"
        bind:reportClick="conditionBarClickReport"
        unionType="{{unionType}}"
        isScramble={{isScramble}}
      />
    </view>
    <view slot="footer" class="footer-button-container" wx:if="{{isScramble}}">
      <view class="scramble-tips" slot="footer-tips">
        <view class="scramble-tips-icon"></view>
        选择车次越多，抢票成功率越高
      </view>
      <view class="footer-button">
        <es-button type="large" custom-class="card-button" bind:click="chooseScrambleTrains">确定</es-button>
      </view>
    </view>
  </es-over-layout>

  <!-- 公告提醒 弹窗 -->
  <notice-popup show="{{ isShowNoticePopup }}" info="{{notice}}" bindclose="hideNoticePop" />

  <!-- 提示弹窗 -->
  <es-toast id="es-toast" />
  <es-dialog id="es-dialog" />
</template>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .list-custom-class
    // background-image url('https://dpubstatic.udache.com/static/dpubimg/4hnS2tq0TNoruy-zYTC4p.png')
    // background-repeat no-repeat
    // background-position center center
    // background-size cover
    // /deep/ .es-main
    //   background transparent
    background #fff
  .list-custom-class-scramble
    background #fff
  .list-header
    background #fff
  .es-navbar-title
    display flex
    justify-content center
    align-items center
    font-size 18px
    font-weight 400
    color #000004
    font-family PingFangSC-Medium
    &-text 
      display flex
      align-items center
  .title-switch-icon
    background url('https://dpubstatic.udache.com/static/dpubimg/jLtzjh7lf8gnyLQmazzrw.png')
    width 12px
    height 10px
    background-size cover
    margin 0 6px
  .es-navbar-right
    font-size 15px
    font-weight 600
    color $train-color-333
  .use-blankp-page-tab 
    .header-item-wrapper
      padding-bottom 12px
    .coupon-banner
      padding 0px 8px 0
      background #f2f6f9
  .train-list-container
    overflow auto
    box-sizing border-box
    padding 0
    position relative
    height 100%
    display flex
    flex-direction column
    .header-item-wrapper
      background #fff
      &.tab
        padding-bottom 12px
      &.sticky
        position sticky
        top 0
        z-index 3
      &.coupon-banner
        padding 0px 8px 0
        background #f2f6f9
      &.guide-tip
        padding 12px 8px 0
        background #f2f6f9
    &.scrambling
      padding-top 8px
      background #F2F6F9
    &-skeleton 
      overflow hidden
    .item-container
      background #f2f6f9
      padding 12px 8px 0 
      flex 1
  .train-list-container-item
    margin-bottom 8px
  .skeleton-container
    background #f0f1f4
  .skeleton
    // height 75%
    // width 96%
    // position absolute
    // top 135px
    // left 10px
    // overflow hidden
    height 100%
    width 100%
    &-item 
      margin 0 10px
      // width 100%
      height 101px
      background #FFFFFF
      border-radius 16px
      position relative
      margin-bottom 8px
      &-1
        position absolute 
        top 14px
        left 16px
        height 38.5px
        width 44px
        background #E4EAEF
        border-radius 5px
      &-2
        position absolute 
        top 18.5px
        left 120px
        height 11px
        width 41px
        background #E4EAEF
        border-radius 5px
      &-3
        position absolute 
        top 42.5px
        left 120px
        height 11px
        width 41px
        background #E4EAEF
        border-radius 5px
      &-4
        position absolute 
        top 14px
        left 221px
        height 38.5px
        width 44px
        background #E4EAEF
        border-radius 5px
      &-5
        position absolute 
        top 17px
        left 295px
        height 20px
        width 44px
        background #FF6400
        border-radius 5px
      &-6
        position absolute 
        top 76px
        left 16px
        height 11px
        width 90px
        background #E4EAEF
        border-radius 5px
  .black-page-line
    background #f2f6f9
    height 12px
    width 100%
  .notice-tips
    display flex
    flex-direction column
  .condition-bar-container
    position relative
  .scramble-tips
    width 100%
    height 40px
    background linear-gradient(0deg, #FFF6F1, #FFF6F1), linear-gradient(270deg, #FFFFFF 3%, #FFF3EB 100%)
    font-family PingFangSC-Regular
    font-size 12px
    color #333333
    line-height 40px
    display flex
    align-items center
    padding-left 19px
    &-icon 
      width 16px
      height 16px
      background url('https://dpubstatic.udache.com/static/dpubimg/TDO9qn7xSN5cWQg3Gi8cE.png')
      background-size cover
      margin-right 4px
  .footer-button-container
    width 100vw
    display flex
    flex-direction column
  .footer-button
    width 100vw
    height 98px
    padding 16px 16px 34px 16px !important
    background-color #ffffff
    box-sizing border-box
  .card-button
    font-size 16px
    font-weight bold
    text-align center
    color white
    border-width 0px
    border-radius 8px
    background-color #FF6400
  .airflow-train-guide-card-container
    background #FFFFFF
    border-radius 16px
    margin-bottom 8px
</style>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { formatDate, getDayByOffset, compare } from '@didi/es-mpx-shared'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import store from '@/store'
  import { getStorage, setStorage } from '@/utils/storage'
  import initMixin from '@/mixins'
  import { trainAuth, loadServiceNotice } from '@/api/train'
  import { isFastDoubleClick } from '@/utils/double-click'
  import { watchEvent } from '@/utils'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'
  import {
    STORAGE_LIST_SEARCH_QUERY,
    STORAGE_CURRENT_SELECTED_CITY,
    STORAGE_DETAIL_SEARCH_QUERY,
    STORAGE_ORIGINAL_LIST_SEARCH_QUERY,
    STORATE_CONDITION_SEARCH_QUERY,
    TRANSFER_TAB_TOGGLE
  } from '@/utils/train-storage'
  import Toast from '@didi/es-mpx-ui/lib/toast/functional'
  import { innerRouter, pagePath, closePage } from '@/common/jump'
  import { trackEvent } from '@/common/track'
  import { parser } from '@didi/trip-service-utils';
  import usexStore from '@/config/usex/lib/store'
  import { addRavenPhoneAndUid } from '@/common/raven-init/init'
  import { goto } from '@didi/spring-base'

  createPage({
    mixins: [initMixin],
    data: {
      navbarStyle: {
        background: '',
        'font-size': '18px',
        'font-weight': 400,
        color: '#000000'
      },
      isFirstLoad: true, // 第一次加载
      travelSystemVisible: false,
      trainListSearchQuery: {},
      isShowNoticePopup: false, // 是否展示公告提醒弹窗
      noticeIndex: 0, // 当前点击的公告index
      serviceNoticeList: [], // 公告信息
      useBlankPage: false,
      blankImageUrl:
        'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png',
      blankContextTitle: '加载失败',
      blankContextSubTitle: LOAD_FAIL_CONTENT,
      hasButton: false,
      time: null,
      headerMaxDateTime: null,
      headerMinDateTime: null,
      linking: true,
      returnPre: true,
      showSkeleton: false,
      chooseTrains: [], // 备选车次 选中列表
      unionType: 0,
      tabList: [
        {
          label: '直达',
          value: 0
        },
        {
          label: '中转',
          value: 1
        }
      ],
      transferLogin: true,
      isAtBottom: false,
      pageNumber: 1,
      noDataTip: false,
      pageLoading: false,
      airflowTrainGuideCardInfo:{}
    },
    computed: {
      ...store.mapState({
        changeOrderInfo: 'change.changeOrderInfo',
        travelList: 'travel.travelList',
        trainListInfo: 'train.trainListInfo',
        trainList: 'train.trainList',
        travel: 'travel.travel',
        scrambleChooseTrains: 'train.scrambleChooseTrains',
        curWatchFun:'coupon.curWatchFun',
        userGroup:'common.userGroup'
      }),
      ...store.mapGetters({
        selectDate: 'travel.selectDate', // 存起来的出发时间
        limitDate: 'change.limitDate', // 限制时间
        selectCityList: 'travel.selectCityList',
        isAliAndNotLogin: 'user.isAliAndNotLogin',
      }),
      showPreScrambleGuide(){
        return this.trainListInfo?.pre_scrambl_flag === 1
      },
      isScramble() {
        // 抢票备选车次页，还是普通车次列表页
        const { order_type } = this.$mpxRoute.query
        return order_type === 'scramble'
      },
      title() {
        return this.selectCityList?.map?.((item) => item.name)
      },
      maxDateTime() {
        const _max = this.fromChangeTicket
          ? this.limitDate?.maxDate
          : this.limitDate?.maxDateForReserve
        return new Date(_max).getTime()
      },
      minDateTime() {
        return new Date(this.limitDate?.minDate).getTime()
      },
      // 公告弹窗信息
      notice() {
        return this.noticeIndex < this.serviceNoticeList?.length
          ? this.serviceNoticeList[this.noticeIndex]
          : {}
      },
      fromChangeTicket() {
        return !!this.changeOrderInfo?.order_id
      },
      changeTicketType() {
        // 1中转
        return this.changeOrderInfo?.order_type
      },
      trackParams() {
        const type = this.fromChangeTicket ? 
                    this.changeTicketType ? 'transitchanges' : 'modify' : 
                    this.unionType ? 'transit' : 'order'
        return { type }
      },
      bookingType() {
        const trainListSearchQuery = this.trainListSearchQuery || {}
        const { booking_type } = trainListSearchQuery
        return booking_type
      },
      current() {
        // 抢票父级车次
        const { train_code } = getStorage(STORAGE_DETAIL_SEARCH_QUERY)
        return this.isScramble ? train_code : undefined
      },
      showUnionLoginCard() {
        return !this.transferLogin && this.unionType
      },
      esMainStyle() {
        const backgroundColor = this.showUnionLoginCard ? '#f2f6f9' : '#fff'
        return {
          background: backgroundColor,
          // overflow: this.showSkeleton ? 'hidden' : ''
        }
      },
      isFromAirflowGuideCard(){
        const { from_guide_card } = this.$mpxRoute.query
        return from_guide_card == 1
      }
    },
    methods: {
      ...store.mapActions({
        getTrainList: 'train.getTrainList',
        getMultiTrainList: 'train.getMultiTrainList',
        initBaichuanTrainPrivacy: 'common.initBaichuanTrainPrivacy',
      }),
      ...store.mapMutations({
        setTravelDate: 'travel.setTravelDate',
        setTrainDetail: 'train.setTrainDetail',
        changeSelectCityList: 'travel.changeSelectCityList',
        setTrainList: 'train.setTrainList',
        setSupplierId: 'train.setSupplierId',
        setTrainDetailRefreshFlag: 'train.setTrainDetailRefreshFlag',
        setScrambleChooseTrains: 'train.setScrambleChooseTrains',
        setCurWatchFun:'coupon.setCurWatchFun',
        setIsTransfer: 'train.setIsTransfer',
        setChangeOrderInfo: 'change.setChangeOrderInfo',
        setHistoryList: 'travel.setHistoryList',
        setGuideTraceId: 'common.setGuideTraceId',
        setBizFrom: 'common.setBizFrom',
      }),
      homeBack() {
        const { from } = this.$mpxRoute.query
        // 指从外部带参数直接跳转到列表页
        if(from === 'outside'){
          closePage()
        } else {
          mpx.$mpxRouter.goback()
        }
      },
      setShowRuleDetail() {
        this.travelSystemVisible = false
      },
      getTrainListApi() {
        return !this.isScramble ? this.getMultiTrainList : this.getTrainList
      },
      /**
       * @method 获取车次列表
       */
      getTrainListFunc(hideLoading = true,isAtBottom = false) {
        this.useBlankPage = false
        if (!hideLoading) {
          this.setTrainList([])
          // mpx.showLoading()
          // this.loading = true
        }
        (!this.unionType || !isAtBottom) && (this.pageNumber = 1)
        if(this.pageNumber === 1) { 
          this.showSkeleton = true
          this.noDataTip = false
        }
        this.pageLoading = true
        !this.isScramble && this.getTrainList({
          ...this.trainListSearchQuery,
          union_type: this.unionType,
          page_number: this.unionType ? this.pageNumber : undefined,
        })
          .then((res) => {
            this.pageLoading = false
            const { code, data, message, success } = res || {}
            if (success) {
              this.airflowTrainGuideCardInfo = data?.airplane_data ? data?.airplane_data[0]??{} : {}
              this.showSkeleton = false
              this.transferLogin = !!data?.is_login
              if (code === '0') {
                // 中转为登录或者非中转
                if (data?.list?.length === 0 && (this.unionType !== 1 || (this.unionType === 1 && this.transferLogin))) {
                  this.useBlankPage = true
                  this.blankImageUrl =
                  'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png' // 空数据
                  this.blankContextTitle = this.unionType === 1 ? '没有找到符合中转方案' : '未找到合适的车次'
                  this.blankContextSubTitle = '换个时间再试试'
                } else {
                  this.blankImageUrl = null
                  this.blankContextTitle = ''
                  this.blankContextSubTitle = ''
                  this.hasButton = false
                }
                // this.noDataTip = (data?.list?.length < 10 || !data?.list || !!data?.is_all_data)
                this.noDataTip = (!data?.list || !!data?.is_all_data)
                trackEvent('userteam_train_tickets_sw', 'UT-火车票-首页-车票列表-曝光', this.trackParams)
              } else {
                if (['10607', '10601'].includes(code)) {
                  Dialog.confirm({
                    title: '温馨提示',
                    message: '当前账号异常，为保证查询，请您重新登录',
                    cancelButtonText: '知道了',
                    confirmButtonText: '去登录',
                    confirm: () => {
                      innerRouter.push(pagePath().LOGIN12306)
                    }
                  })
                } 
                if(this.transferLogin || !this.unionType) {
                  this.useBlankPage = true
                }
                else { this.useBlankPage = false }
                this.blankImageUrl =
                  'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png' // 空数据
                this.blankContextTitle = this.unionType === 1 ? '没有找到符合中转方案' : '未找到合适的车次'
                this.blankContextSubTitle = '换个时间再试试'
                this.hasButton = false
                if(this.transferLogin || !this.unionType) {
                    trackEvent(
                    'userteam_train_tickets_noresult_sw',
                    'UT-火车票-首页-车票列表无结果-曝光',
                    this.trackParams
                  )
                }
              }
            } else {
              this.useBlankPage = true
              this.showSkeleton = false
              this.blankImageUrl =
                'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
              this.blankContextTitle = '加载失败'
              this.blankContextSubTitle = LOAD_FAIL_CONTENT
              this.hasButton = true
            }
          })
          .catch((e) => {
            this.pageLoading = false
            this.useBlankPage = true
            this.showSkeleton = false
            this.blankImageUrl =
              'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
            this.blankContextTitle = '加载失败'
            this.blankContextSubTitle = LOAD_FAIL_CONTENT
            this.hasButton = true
          })
          // .finally(() => {
          //   debugger
          //   this.showSkeleton = false
          //   // mpx.hideLoading()
          // })
        // 抢票车次列表
        const { date } = this.$mpxRoute.query
        const dateArr = date?.split('*')
        // 精确查询参数
        const detailQueryParams = {
          from_station_name: getStorage(STORAGE_DETAIL_SEARCH_QUERY).from_station_name,
          to_station_name: getStorage(STORAGE_DETAIL_SEARCH_QUERY).to_station_name,
          // from_prefect_match: 1,
          // to_prefect_match: 1,
          from_city_match: getStorage(STORAGE_DETAIL_SEARCH_QUERY).from_station_name,
          to_city_match: getStorage(STORAGE_DETAIL_SEARCH_QUERY).to_station_name
        }
        const query = { ...this.trainListSearchQuery, train_date_list: JSON.stringify(dateArr), ...detailQueryParams } 
        this.isScramble && this.getMultiTrainList(query)
          .then((res) => {
            const { code, data, message, success } = res || {}
            if (success) {
              this.showSkeleton = false
              if (code === '0' && data?.list?.length) {
                this.useBlankPage = false
                this.blankImageUrl = null
                this.blankContextTitle = ''
                this.blankContextSubTitle = ''
                this.hasButton = false
              } else {
                this.useBlankPage = true
                this.blankImageUrl =
                  'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png' // 空数据
                this.blankContextTitle = '未找到合适的车次'
                this.blankContextSubTitle = '换个时间再试试'
                this.hasButton = false
                // trackEvent(
                //   'userteam_train_tickets_noresult_sw',
                //   'UT-火车票-首页-车票列表无结果-曝光',
                //   this.trackParams
                // )
              }
            } else {
              this.useBlankPage = true
              this.blankImageUrl =
                'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
              this.blankContextTitle = '加载失败'
              this.blankContextSubTitle = LOAD_FAIL_CONTENT
              this.hasButton = true
            }
          })
          .catch((e) => {
            console.log('error', e)
          })
          // .finally(() => {
          //   // debugger
          //   this.showSkeleton = false
          //   // mpx.hideLoading()
          // })
      },
      // 展示公告弹窗
      showTipsPop(index) {
        this.noticeIndex = index
        this.isShowNoticePopup = true
      },
      // 隐藏公告弹窗
      hideNoticePop() {
        this.isShowNoticePopup = false
      },
      getServiceNotice() {
        const params = {
          source_service: 'train',
          from_city: this.selectCityList?.[0]?.id,
          to_city: this.selectCityList?.[1]?.id
        }
        loadServiceNotice(params).then((res) => {
          if (res?.success) {
            if (res?.code === '0') {
              this.serviceNoticeList = res?.data?.notice_list
            }
          }
        })
      },
      /**
       * @method 点击List
       */
      goDetail(params, index) {
        trackEvent('userteam_train_tickets_card_ck', 'UT-火车票-车票列表-车票卡片-点击', {
          ...this.trackParams,
          index
        })
        if (isFastDoubleClick() && !this.isScramble) {
          return
        }
        if (params.sale_flag) {
          // 列车调整，无法点击
          return
        }
        if (!this.hasTicket(params) && this.fromChangeTicket) {
          Toast({
            message: '当前车次无票,请选择其他车次',
            overlay: false
          })
          return
        }
        if(this.isScramble) {
          // 抢票
          if(params.train_code === this.current) {
            // 父级车次，不可操作
            return
          } else {
            // this.chooseTrains = this.scrambleChooseTrains
            if(this.scrambleInclude(params)) {
              // 取消
              this.chooseTrains = this.chooseTrains.filter(item => item.train_no !== params.train_no)
            } else {
              if(this.chooseTrains?.length > 10) {
                mpx.showToast({
                  title: '只能选择10个备选车次',
                  icon: 'none'
                })
                return 
              }
              // 勾选
              this.chooseTrains.push(params)
            }
          }
        } else {
          // 正常流程跳转车次详情
          this.toNextPage(params)
        }
      },
      hasTicket(ticketItem) {
        for (var i in ticketItem.ticket_data) {
          if (ticketItem.ticket_data[i].ticket_num !== '无票') {
            return true
          }
        }
        return false
      },
      scrambleInclude(params) {
        return this.chooseTrains.some(item => {
            return item.train_no === params.train_no
          })
      },
      toNextPage(params) {
        if(this.isAliAndNotLogin) {
          return usexStore.dispatch('getToken', true).then((res) => {
            addRavenPhoneAndUid(res)
          })
        }
        const url = this.userGroup ? pagePath().MAKEORDER : pagePath().TRAINDETAIL
        this.setTrainDetail(params)
        trackEvent('next-page-params', '排查--用户跳转选择参数', params)
        params?.supplier_id && this.setSupplierId(params?.supplier_id)
        setStorage({ key: STORAGE_DETAIL_SEARCH_QUERY, data: params })
        this.setIsTransfer(!!this.unionType)
        const { from } = this.$mpxRoute.query
        innerRouter.push(url, {
          from: from,
        })
      },
      updateData({ detail: { key, value } }) {
        this[key] = value
      },
      timeChange(val) {
        this.time = [val]
        const differ = 15 * 24 * 60 * 60 * 1000
        const flag1 = this.maxDateTime - val < differ
        this.headerMaxDateTime = flag1 ? this.maxDateTime : ''
        this.headerMinDateTime = this.minDateTime
      },
      changeDate(data) {
        const date = new Date(data?.[0]).setHours(8)
        // 车次列表搜索参数更新
        let searchQuery = { ...this.trainListSearchQuery }
        const compareTime = compare(getDayByOffset(Date.now(), 59).getTime(), date)
        if (compareTime >= 0) {
          if (
            formatDate(date, 'YYYY-MM-dd') !== searchQuery?.train_date &&
            date <= this.maxDateTime &&
            date >= this.minDateTime
          ) {
            // 选中日期保存更新
            this.setTravelDate(date)
            this.timeChange(date)
            searchQuery = {
              ...searchQuery,
              train_date: formatDate(date, 'YYYY-MM-dd')
            }
            !this.isScramble &&
              setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: searchQuery })
            this.trainListSearchQuery = searchQuery
            this.getTrainListFunc(false)
          }
        } else {
          Toast({
            message: '您所选择的日期列车暂未开售，请选择其他日期',
            overlay: false
          })
          if (this.returnPre) {
            this.$refs?.es_date?.returnToPre?.() // 小程序
            this.$refs?.__mpx_ref_es_date__?.returnToPre?.() // h5
          } else {
            this.linking = false
            setTimeout(() => {
              this.linking = true
            }, 500)
          }
        }
        this.returnPre = true
      },
      onConfirm(data) {
        this.returnPre = false
        this.changeDate.call(this, data.detail)
      },
      async handleClickDay(data) {
        this.changeDate.call(this, data.detail.data)
      },
      /**
       * @description: 空白页按钮点击事件
       */
      clickButton() {
        console.log('加载失败重试按钮事件')
        this.getTrainListFunc(false)
      },
      backFill() {
        // 此处用来防止用户刷新页面后返回首页 选中的城市不对的情况
        const trainListSearchQuery = { ...this.trainListSearchQuery }
        this.changeSelectCityList({
          type: 'currentFromCity',
          data: this.selectCityList?.[0]
        })
        this.changeSelectCityList({
          type: 'currentToCity',
          data: this.selectCityList?.[1]
        })

        const val = new Date(trainListSearchQuery?.train_date).getTime() || new Date().getTime()
        this.setTravelDate(val)
        this.timeChange(val)
      },
      conditionBarClickReport(params) {
        const text = params?.detail
        trackEvent('userteam_train_tickets_screen_ck', 'UT-火车票-车票列表-车票卡片-点击', {
          ...this.trackParams,
          text
        })
      },
      goBackReport() {
        trackEvent(
          'userteam_train_tickets_return_ck',
          'UT-火车票-车票列表-返回-点击',
          this.trackParams
        )
      },
      chooseScrambleTrains() {
        this.setScrambleChooseTrains(this.chooseTrains)
        setTimeout(() => {
          innerRouter.goback()
        }, 100)
      },
      reverseCity() {
        if(this.pageLoading) return 
        // 切换起终点城市
        const fromCity = this.selectCityList?.[1]
        const toCity = this.selectCityList?.[0]
        this.changeSelectCityList({
          type: 'currentFromCity',
          data: fromCity
        })
        this.changeSelectCityList({
          type: 'currentToCity',
          data: toCity
        })
        // 重置所有的筛选项
        setStorage({ key: STORATE_CONDITION_SEARCH_QUERY, data: {} })
        const query = {
          from_station_name: fromCity?.name,
          to_station_name: toCity?.name,
          from_city_match: '',
          to_city_match: '',
          train_type_code: '',
          start_time_list: JSON.stringify([]),
          end_time_list: JSON.stringify([]),
          order_by_start_time: '0',
          is_fxh: '0',
          is_zndc: '0',
          is_quiet: '0',
          order_by: 'start',
          order_rules: 'asc',
          preferred_tickets: '0',
          from_prefect_match: 0,
          to_prefect_match: 0,
          passenger_type: 11,
          transfer_station_type: 0,
          transfer_city_match: []
        }
        this.trainListSearchQuery = {...this.trainListSearchQuery, ...query}
        !this.isScramble &&
              setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: this.trainListSearchQuery })
        this.getTrainListFunc()
      },
      resetAllConditions() {
        setStorage({ key: STORATE_CONDITION_SEARCH_QUERY, data: {} })
        const order_by_start_time = this.unionType ? '' : '0'
        const order_by = this.unionType ? '' : 'start'
        const order_rules = this.unionType ? '' : 'asc'
        const query = {
          from_city_match: '',
          to_city_match: '',
          train_type_code: '',
          start_time_list: JSON.stringify([]),
          end_time_list: JSON.stringify([]),
          order_by_start_time,
          is_fxh: '0',
          is_zndc: '0',
          is_quiet: '0',
          order_by,
          order_rules,
          preferred_tickets: '0',
          from_prefect_match: 0,
          to_prefect_match: 0,
          // passenger_type: 11,
          transfer_station_type: 0,
          transfer_city_match: [],
        }
        this.trainListSearchQuery = {...this.trainListSearchQuery, ...query}
        !this.isScramble &&
          setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: this.trainListSearchQuery })
      },
      setUnionType(e) {
        const value = e?.detail || 0
        this.unionType = value
        const module = this.unionType ? 'transit' : 'direct'
        trackEvent('userteam_train_tickets_tab_ck','UT-火车票-车票列表-tab按钮-点击', { module })
        this.resetAllConditions()
        // this.$refs.normalContionBar.saveConditionQuery()
        this.getTrainListFunc(false)
      },
      handleScroll({ target }) {
        if(!this.unionType) return 
        const { offsetHeight, scrollTop, scrollHeight } = target
        this.isAtBottom =
          scrollHeight - scrollTop - offsetHeight < 50 && scrollTop !== 0
      },
      gotoFlightList(){
        const arr_city_code = this.airflowTrainGuideCardInfo.arr_city_code
        const arr_city_name = this.airflowTrainGuideCardInfo.arr_city_name
        const dep_city_code = this.airflowTrainGuideCardInfo.dep_city_code
        const dep_city_name = this.airflowTrainGuideCardInfo.dep_city_name
        const date = this.airflowTrainGuideCardInfo.date
        const url = `https://v.didi.cn/qXPExoZ?from_guide_card=1&dcc=${dep_city_code}&dcn=${dep_city_name}&acc=${arr_city_code}&acn=${arr_city_name}&date=${date}`
        goto({ url })
      }
    },
    watch: {
      selectDate: {
        immediate: true,
        deep: true,
        handler(val) {
          if (!this.time) {
            this.timeChange(val)
          }
        }
      },
      isScramble: {
        handler(val,old) {
          if(val !== old) {
            this.isFirstLoad = true
          }
        } 
      },
      trainList: {
        immediate: true,
        handler(val) {
          if (val && val.length) {
            this.showSkeleton = false
          }
        }
      },
      isAtBottom: {
        handler(val) {
          val &&
            setTimeout(() => {
              if (!this.pageLoading && !this.noDataTip) {
                this.pageNumber++
                this.getTrainListFunc(true,true)
              }
            }, 300)
        },
        immediate: false,
      },
      fromChangeTicket: {
        handler(val) {
          val && (this.unionType = 0)
        },
        immediate: true
      }
    },
    onShow() {
      this.setTrainDetailRefreshFlag(true)
      const trainListSearchQuery = (this.isScramble
        ? getStorage(STORAGE_ORIGINAL_LIST_SEARCH_QUERY)
        : getStorage(STORAGE_LIST_SEARCH_QUERY)) || {}
      this.trainListSearchQuery = { ...trainListSearchQuery }
      this.isScramble && this.$refs.conditionbar?.resetCondition && this.$refs.conditionbar?.resetCondition()
      const val = new Date(trainListSearchQuery?.train_date).getTime() || new Date().getTime()
      this.setTravelDate(val)
      this.trainListSearchQuery.train_date = trainListSearchQuery?.train_date

      this.timeChange(val)
      this.getTrainListFunc(!this.isFirstLoad)
      this.isFirstLoad = false
      this.chooseTrains = [].concat(this.scrambleChooseTrains)
    },
    onHide() {
      // 此处用来防止用户刷新页面后返回首页 选中的城市不对的情况
      this.backFill()
      
    },
    created(){
      const { from, fromCity, toCity, date, checkboxValue, bizFrom, guideTraceId } = this.$mpxRoute.query
      // 指从外部带参数直接跳转到列表页
      if(from === 'outside'){
        this.setChangeOrderInfo({})
        const fromCityObj= fromCity ? parser.parse(fromCity) : {};
        const toCityObj= toCity? parser.parse(toCity) : {};
        const checkboxValueObj = checkboxValue ? parser.parse(checkboxValue) : [];
        const { 
          name: from_station_name, 
          city_id: from_city_id,
          city_name :from_city_name,
          precise_search: from_precise_search
        } = fromCityObj
        const {
          name: to_station_name,
          city_id: to_city_id,
          city_name: to_city_name,
          precise_search: to_precise_search
        } = toCityObj
        const train_date = formatDate(date, 'YYYY-MM-dd')
        const query = {
          train_date: train_date,
          from_station_name: from_station_name,
          to_station_name: to_station_name,
          from_city_match: '',
          to_city_match: '',
          train_type_code: checkboxValueObj.includes('only_high') ? 'G,C,D' : '',
          start_time_list: JSON.stringify([]),
          end_time_list: JSON.stringify([]),
          order_by_start_time: '0',
          is_fxh: '0',
          is_zndc: '0',
          is_quiet: '0',
          order_by: 'start',
          order_rules: 'asc',
          preferred_tickets: '0',
          from_prefect_match: 0,
          to_prefect_match: 0,
          passenger_type: checkboxValueObj.includes('student') ? 13 : 11
        }
        const scrambleQuery = {
          train_date: train_date,
          from_station_name: from_station_name,
          to_station_name: to_station_name,
          from_city_match: '',
          to_city_match: '',
          train_type_code: '',
          start_time_list: JSON.stringify([]),
          end_time_list: JSON.stringify([]),
          order_by_start_time: '0',
          is_fxh: '0',
          is_zndc: '0',
          is_quiet: '0',
          order_by: 'start',
          order_rules: 'asc',
          preferred_tickets: '0',
          from_prefect_match: 0,
          to_prefect_match: 0,
          passenger_type: checkboxValueObj.includes('student') ? 13 : 11
        }
        const fromCityReal = {
          id: from_city_id,
          name: from_station_name,
          precise_search: from_precise_search,
          subName: from_city_name,          
        }
        const toCityReal = {
          id: to_city_id,
          name: to_station_name,
          precise_search: to_precise_search,
          subName: to_city_name,
        }

        const selectCityList = [ fromCityReal,toCityReal ]
        setStorage({ key: STORAGE_CURRENT_SELECTED_CITY, data: selectCityList })
        setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: query })
        setStorage({ key: STORAGE_ORIGINAL_LIST_SEARCH_QUERY, data: scrambleQuery })
        setStorage({ key: STORATE_CONDITION_SEARCH_QUERY, data: {} })
        this.setHistoryList(JSON.parse(JSON.stringify(selectCityList)))
        this.changeSelectCityList({
          type: 'currentFromCity',
          data: fromCityReal
        })
        this.changeSelectCityList({
          type: 'currentToCity',
          data: toCityReal
        })
        // 勾选了高铁动车和学生票筛选后，把筛选条件带到列表页
        const _condition = {
          train_type_code: checkboxValueObj.includes('only_high') ? ['G','C','D'] : [],
          passenger_type: checkboxValueObj.includes('student') ? '13' : '11',
          start_time_list: [],
          end_time_list: [],
          from_city_match: [],
          to_city_match: []
        }
        setStorage({
          key: STORATE_CONDITION_SEARCH_QUERY,
          data: _condition
        })
      }
      this.setGuideTraceId(guideTraceId)  //城际跳转id
      this.setBizFrom(bizFrom)
      this.initBaichuanTrainPrivacy()
    },
    mounted() {
      // 此处用于确保data里保存的参数和被选中城市列表数据是最新的
      const trainListSearchQuery = (this.isScramble
        ? getStorage(STORAGE_ORIGINAL_LIST_SEARCH_QUERY)
        : getStorage(STORAGE_LIST_SEARCH_QUERY)) || {}

      this.trainListSearchQuery = { ...trainListSearchQuery }
      // // 时间处理
      // const val = new Date(trainListSearchQuery.train_date).getTime() || new Date().getTime()
      // this.setTravelDate(val)
      // this.timeChange(val)

      // 监听车次列表更新事件
      // watchEvent('updateTrainList', () => this.getTrainListFunc())
      watchEvent('updateTrainList', this.getTrainListFunc, this.curWatchFun )
      this.setCurWatchFun(this.getTrainListFunc)

      this.getServiceNotice()
      mpx.setNavigationBarColor({ frontColor: '#000000' })
      // 跳到这个页面，要更新好local里的query
      // 筛选条件用setStorage存在本地，key值：es_h5_train_list_search_query
    },
    onUnload() {
      // 此处用来防止用户刷新页面后返回首页 选中的城市不对的情况
      this.backFill()  
    }
  })
</script>

<script name="json">
  module.exports = {
    usingComponents: {
      'coupon-banner-simplify': '@/components/coupon/coupon-banner-simplify',
      'es-over-layout': '@/es-mpx-ui/lib/layout',
      'train-info-card': './components/train-info-card',
      'travel-system-drawer': '@/components/travel-system-drawer',
      'train-list-condition-bar': './components/train-list-condition-bar',
      'id-authorize': './components/id-authorize',
      'es-toast': '@didi/es-mpx-ui/lib/toast',
      'notice-tip': '@/material/block/notice/noticeTip',
      'notice-popup': '@/material/block/notice/noticePopup',
      'change-navbar': '@/components/change-navbar',
      'es-date': '@/material/element/calendar-date',
      'guide-tips':'./components/guide-tips',
      'top-condition-bar': './components/top-condition-bar',
      'Tab': '@/components/tab',
      'union-login-card': './components/union-login-card',
      'Loading': '@/components/loading',
      'airflow-train-guide-card':'@didi/spring-ui/airflow-train-guide-card'
    }
  }
</script>
